import * as Yup from "yup";
import { StringValidation, DropdownValidation } from "./PlanSchema";

export const PeriodSchema = Yup.object().shape({
  name: StringValidation.label("Name"),
  close_period_mode: DropdownValidation.label("Close Period Mode"),
});
